// Aggregator for partner brands. Each brand is defined in ./data/<brand>.js
import { INTELBRAS } from "./data/intelbras";
import { MOTOROLA } from "./data/motorola";
import { HYTERA } from "./data/hytera";
import { CISCO } from "./data/cisco";
import { ALCATEL } from "./data/alcatel";
import { DSTV } from "./data/dstv";
import { VSAT } from "./data/vsat";

export const PARTNER_BRANDS = [
  INTELBRAS,
  MOTOROLA,
  HYTERA,
  CISCO,
  ALCATEL,
  DSTV,
  VSAT,
];

export const partnerStrings = {
  pt: {
    overline: "Marcas Representadas",
    title: "Equipamentos internacionais de fiabilidade comprovada.",
    details_title: "Parceiros em destaque",
    details_subtitle:
      "Conheça os equipamentos que representamos, comercializamos e assistimos em Angola.",
    catalog_label: "Catálogo",
    pillars_label: "Pilares",
    segments_label: "Segmentos atendidos",
    solutions_title: "As nossas soluções",
    solutions_subtitle:
      "Tecnologia, experiência e atenção ao detalhe para aprimorar cada etapa da operação do seu negócio.",
    cta_proposal: "Solicitar proposta",
    cta_interested: "Tenho interesse",
    card_quote_cta: "Pedir orçamento",
    quote_modal: {
      title: "Pedido de orçamento",
      subtitle: "Preencha os seus dados e a nossa equipa entra em contacto em 24h.",
      product_label: "Produto de interesse",
      name: "Nome completo",
      name_ph: "O seu nome",
      email: "Email",
      email_ph: "email@exemplo.com",
      phone: "Telefone",
      phone_ph: "900 000 000",
      company: "Empresa (opcional)",
      company_ph: "Nome da sua empresa",
      message: "Mensagem",
      message_ph: "Quantidade, prazos ou detalhes adicionais…",
      submit: "Enviar pedido",
      sending: "A enviar…",
      required: "Preencha nome, email e mensagem.",
      success: "Pedido enviado! Entraremos em contacto brevemente.",
      error: "Não foi possível enviar. Tente novamente mais tarde.",
      subject_prefix: "Pedido de orçamento",
    },
  },
  en: {
    overline: "Represented Brands",
    title: "Internationally trusted equipment, field-proven reliability.",
    details_title: "Featured partners",
    details_subtitle:
      "Discover the equipment we represent, sell and service in Angola.",
    catalog_label: "Catalog",
    pillars_label: "Pillars",
    segments_label: "Segments served",
    solutions_title: "Our solutions",
    solutions_subtitle:
      "Technology, experience and attention to detail to improve every step of your operation.",
    cta_proposal: "Request a proposal",
    cta_interested: "I'm interested",
    card_quote_cta: "Request a quote",
    quote_modal: {
      title: "Request a quote",
      subtitle: "Fill in your details and our team will get back to you within 24h.",
      product_label: "Product of interest",
      name: "Full name",
      name_ph: "Your name",
      email: "Email",
      email_ph: "email@example.com",
      phone: "Phone",
      phone_ph: "900 000 000",
      company: "Company (optional)",
      company_ph: "Your company name",
      message: "Message",
      message_ph: "Quantity, deadlines or extra details…",
      submit: "Send request",
      sending: "Sending…",
      required: "Please fill in name, email and message.",
      success: "Request sent! We'll be in touch shortly.",
      error: "Couldn't send. Please try again later.",
      subject_prefix: "Quote request",
    },
  },
  es: {
    overline: "Marcas representadas",
    title: "Equipos internacionales de fiabilidad comprobada.",
    details_title: "Socios destacados",
    details_subtitle:
      "Descubre los equipos que representamos, vendemos y asistimos en Angola.",
    catalog_label: "Catálogo",
    pillars_label: "Pilares",
    segments_label: "Segmentos atendidos",
    solutions_title: "Nuestras soluciones",
    solutions_subtitle:
      "Tecnología, experiencia y atención al detalle para mejorar cada etapa de tu operación.",
    cta_proposal: "Solicitar propuesta",
    cta_interested: "Tengo interés",
    card_quote_cta: "Pedir cotización",
    quote_modal: {
      title: "Solicitar cotización",
      subtitle: "Completa tus datos y nuestro equipo te contactará en 24h.",
      product_label: "Producto de interés",
      name: "Nombre completo",
      name_ph: "Tu nombre",
      email: "Email",
      email_ph: "email@ejemplo.com",
      phone: "Teléfono",
      phone_ph: "900 000 000",
      company: "Empresa (opcional)",
      company_ph: "Nombre de tu empresa",
      message: "Mensaje",
      message_ph: "Cantidad, plazos o detalles adicionales…",
      submit: "Enviar solicitud",
      sending: "Enviando…",
      required: "Completa nombre, email y mensaje.",
      success: "¡Solicitud enviada! Te contactaremos pronto.",
      error: "No se pudo enviar. Intenta de nuevo más tarde.",
      subject_prefix: "Solicitud de cotización",
    },
  },
};
